import {
  Loading,
  Swipe,
  SwipeItem,
  Collapse,
  CollapseItem,
  Cell,
  CellGroup,
  Icon,
  Skeleton,
  List,
  Button,
  Overlay,
  Sticky,
  NavBar,
  Tag,
  Search,
  Field,
  Toast,
  Notify,
  ActionSheet,
  Popup,
  Tabbar,
  NoticeBar,
  NumberKeyboard,
  RadioGroup,
  Radio,
  Uploader,
  Checkbox,
  Rate,
  Stepper,
  DropdownItem,
  DropdownMenu,
  Area,
  AddressEdit,
  Cascader,
  Form,
  SwipeCell,
  Popover,

  // Dialog,
} from "vant";
import scroll from "../components/scroll.vue";
const vant = {
  install: function(Vue) {
    Vue.component('Swipe', Swipe)
    Vue.component('SwipeItem', SwipeItem)
    Vue.component("Tag", Tag);
    Vue.component("Button", Button);
    Vue.component("NavBar", NavBar);
    Vue.component("Search", Search);
    Vue.component("Field", Field);
    Vue.component("Cell", Cell);
    Vue.component("CellGroup", CellGroup);
    Vue.component("Toast", Toast);
    Vue.component("Notify", Notify);
    Vue.component("Overlay", Overlay);
    Vue.component("ActionSheet", ActionSheet);
    Vue.component("Popup", Popup);
    Vue.component("Tabbar", Tabbar);
    Vue.component("NoticeBar", NoticeBar);
    Vue.component("vanNumberKeyboard", NumberKeyboard);
    Vue.component("Radio", Radio);
    Vue.component("RadioGroup", RadioGroup);
    Vue.component("List", List);
    Vue.component("Sticky", Sticky);
    Vue.component("Loading", Loading);
    Vue.component("Uploader", Uploader);
    Vue.component("Checkbox", Checkbox);
    Vue.component("Rate", Rate);
    Vue.component("Icon", Icon);
    Vue.component('Skeleton', Skeleton)
    Vue.component("Collapse", Collapse);
    Vue.component("CollapseItem", CollapseItem);
    Vue.component("Stepper", Stepper);
    Vue.component("DropdownItem", DropdownItem);
    Vue.component("DropdownMenu", DropdownMenu);
    Vue.component("Area", Area);
    Vue.component("AddressEdit", AddressEdit);
    Vue.component("Cascader", Cascader);
    Vue.component("Form", Form);
    Vue.component("SwipeCell", SwipeCell);
    Vue.component("Popover", Popover);
    // Vue.component('Dialog', Dialog)

    Vue.component("scroll", scroll);
  }
};
export default vant;
